
import 'moment/locale/ru'
import moment from 'moment'
import GbArrowNavigation from '../../../../components/ArrowNavigation/ArrowNavigation.vue'
import Helpers from '../../../../utils/helpers'

export default {
  name: 'CalendarHeader',
  components: { GbArrowNavigation },
  props: {
    useSelects: {
      type: Boolean,
      default: true
    },

    currentDate: {
      type: Object,
      required: true
    }
  },

  data() {
    const currentYear = moment().year()

    return {
      years: Array.from({ length: currentYear - 2015 }, (_, i) => currentYear + 2 - i).reverse(),

      months: moment.months().map(e => Helpers.firstLetterUpperCase(e))
    }
  },

  computed: {
    monthSelectWidth() {
      const optionLength = this.months[this.selectedMonth].length

      return (
        {
          3: '50px',
          4: '60px',
          5: '70px',
          6: '78px',
          7: '90px',
          8: '100px'
        }[optionLength] || 'auto'
      )
    },

    selectedMonth: {
      get() {
        return this.currentDate.month()
      },

      set(month) {
        const year = this.currentDate.year()
        this.$emit('month-change', moment([year, month]))
      }
    },

    selectedYear: {
      get() {
        return this.currentDate.year()
      },

      set(year) {
        const month = this.currentDate.month()
        this.$emit('year-change', moment([year, month]))
      }
    }
  },

  watch: {
    selectedYear(newVal) {
      if (!this.years.includes(newVal)) {
        newVal < this.years[0] ? this.years.unshift(newVal) : this.years.push(newVal)
      }
    }
  },

  methods: {
    prevMonth() {
      this.$emit('month-change', moment(this.currentDate.subtract(1, 'month')))
    },

    nextMonth() {
      this.$emit('month-change', moment(this.currentDate.add(1, 'month')))
    }
  }
}
